import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';
import BirthdayCelebration from '../Celebration';

const ModalOverlay = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  paddingTop: '25px',
  zIndex: 1000,
});

const ModalContent = styled('div')(({ modalHeight }) => ({
  backgroundColor: '#fff',
  padding: '30px',
  borderRadius: '12px',
  boxShadow: '0 6px 18px rgba(0, 0, 0, 0.3)',
  width: '100%',
  maxWidth: '600px',
  minHeight: modalHeight || '280px',
  maxHeight: '80vh',
  overflowY: 'hidden',
  overflowX: 'hidden',
  position: 'relative',
  textAlign: 'center',
}));

const ModalHeader = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
});

const CloseButton = styled('button')({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '20px',
  color: '#888',
});

const Title = styled('h2')({
  fontSize: '24px',
  margin: '20px 0 10px',
  color: '#2d3748',
});

const Subtext = styled('p')({
  fontSize: '16px',
  color: '#4a5568',
  marginBottom: '20px',
});

const ActionButton = styled('button')({
  backgroundColor: '#623C91',
  color: 'white',
  padding: '12px 20px',
  borderRadius: '8px',
  border: 'none',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: '16px',
  marginTop: '15px',
  width: '70%',
  '&:hover': {
    backgroundColor: '#512981',
  },
});

const SuccessModal = ({ isOpen, onClose, userType, modalHeight }) => {
  if (!isOpen) return null;

  const isDSO = userType === 'DSO';
  const handleCloseModal = () => {
    if (onClose) onClose();
  };

return (
    <ModalOverlay>
        <ModalContent modalHeight={modalHeight}>
     <BirthdayCelebration />
            <ModalHeader style={{ position: 'absolute', top: 3, right: 8, width: '100%', justifyContent: 'flex-end' }}>
                <CloseButton onClick={handleCloseModal}>
                    <CloseIcon />
                </CloseButton>
            </ModalHeader>


            <Title style={{marginTop:'15px'}}> Congratulations!</Title>

            <Subtext>
                {isDSO
                    ? 'Your company profile is complete. You can now invite advertisers, approve campaigns, and grow your network.'
                    : 'You are now ready to explore the network, send campaign proposals, and connect with display owners.'}
            </Subtext>

            <ActionButton
                as={Link}
                to={isDSO ? '/advertiser' : '/advertisers-displays'}
                style={{ display: 'block', margin: '20px auto 0' }}
                onClick={handleCloseModal}
            >
                {isDSO ? 'Invite Advertisers' : 'Connect with Display Owners'}

            </ActionButton>
            <ActionButton
                as={Link}
                to="/settings/:profile"
                style={{ display: 'block', margin: '20px auto 0' }}
                onClick={handleCloseModal}
            >
                Edit Profile
            </ActionButton>
        </ModalContent>
    </ModalOverlay>
);
};

export default SuccessModal;
